// extracted by mini-css-extract-plugin
export default {"makeDefaultButton":"DefaultPayment_makeDefaultButton__9moFe","default":"DefaultPayment_default__1cmV+"};